import React from 'react';
import { CalendarProvider } from '../contexts/CalendarContext';
import CalendarView from '../components/calendar/CalendarView';

const CalendarPage = () => {
  return (
    <CalendarProvider>
      <CalendarView />
    </CalendarProvider>
  );
};

export default CalendarPage;
